'use strict';

import {ewModel} from './ewmodel.js';

export class userModel extends ewModel
{
	agreement = false;
	phone = '';
	phoneInput = '';
	
	constructor(itemData){
		super(itemData);
		this.setupItemData(itemData);
	}
	
}